import { render, staticRenderFns } from "./StatusSetting.vue?vue&type=template&id=00ce074e"
import script from "./StatusSetting.vue?vue&type=script&lang=js"
export * from "./StatusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports